function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import { Button } from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './nurture-ai.scss';
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
var NurtureAI = function NurtureAI(_ref) {
  var className = _ref.className,
    buttonText = _ref.buttonText,
    display = _ref.display,
    open = _ref.open,
    children = _ref.children,
    done = _ref.done,
    subtitle = _ref.subtitle,
    onBegin = _ref.onBegin;
  var _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    showChildren = _useState2[0],
    setShowChildren = _useState2[1];
  var toggleModal = function toggleModal() {
    return setShowChildren(!showChildren);
  };
  var begin = function begin() {
    if (typeof onBegin === 'function') onBegin(); // Notify consumer that AI generation is about to start
    setShowChildren(true);
  };
  useEffect(function () {
    if (done) setShowChildren(false);
  }, [done]);
  return /*#__PURE__*/React.createElement("div", {
    className: "nurture-ai ".concat(className, " py-2 p-3")
  }, /*#__PURE__*/React.createElement("div", {
    className: "nurture-ai-header d-flex justify-content-between flex-wrap align-items-center border-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-size-17 mb-1"
  }, "Nurture Assistant \u2728 "), /*#__PURE__*/React.createElement("div", {
    className: "font-size-14"
  }, subtitle, " ")), (!showChildren || display === 'modal') && /*#__PURE__*/React.createElement(Button, {
    color: "light",
    onClick: begin
  }, buttonText), showChildren && display === 'expand' && /*#__PURE__*/React.createElement(Button, {
    color: "light",
    className: "btn-circle text-secondary",
    onClick: function onClick() {
      return setShowChildren(false);
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimes
  }))), showChildren && display === 'expand' && /*#__PURE__*/React.createElement("div", {
    className: "nurture-ai-body py-4 px-1 px-sm-3"
  }, children), display === 'modal' && /*#__PURE__*/React.createElement(Modal, {
    modalClassName: "Nurture-React",
    centered: true,
    size: "lg",
    fullscreen: "sm",
    isOpen: showChildren,
    toggle: toggleModal,
    zIndex: 1033
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: toggleModal
  }, /*#__PURE__*/React.createElement("div", {
    className: "nurture-ai-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-size-17"
  }, "Nurture Assistant \u2728"))), /*#__PURE__*/React.createElement(ModalBody, {
    className: "px-0 pb-0"
  }, children)));
};
NurtureAI.defaultProps = {
  className: 'my-3',
  display: 'expand',
  subtitle: 'comment',
  done: false,
  // The consumer of this component informs it is done, so hide modal or expanded
  open: false
};
export default NurtureAI;